export enum MARKETING_CONVERSION_EVENTS {
  EMAIL_LEAD = 'EMAIL_LEAD',
  USER_CREATED = 'USER_CREATED',
  BROKERAGE_ACCOUNT_CREATED = 'BROKERAGE_ACCOUNT_CREATED',
  HIGH_VALUE_USER = 'HIGH_VALUE_USER',
  LINKED_BANK = 'LINKED_BANK',
  TRADE_DOCS_SIGNED = 'TRADE_DOCS_SIGNED',
}
